<script setup lang="ts">
import { useBreakpoints, breakpointsTailwind } from '@vueuse/core'
import type { SidenavType } from '@/composables/useSidenav'

const { isOpen } = useSidenav()

const breakpoints = useBreakpoints(breakpointsTailwind)
const isDesktop = breakpoints.greaterOrEqual('md')

const contexts: Array<{
    type: SidenavType
    direction: 'left' | 'right' | 'bottom'
    widthClass: string
    component: ReturnType<typeof defineAsyncComponent>
}> = [
    {
        type: 'cart',
        get direction() { return isDesktop.value ? 'right' : 'bottom' },
        widthClass: 'w-full md:w-[440px]',
        component: defineAsyncComponent(() => import('../drawer/DrawerContextCart.vue')),
    },
    {
        type: 'menu',
        direction: 'right',
        widthClass: 'w-full md:w-[440px]',
        component: defineAsyncComponent(() => import('../drawer/DrawerContextMenu.vue')),
    },
    {
        type: 'search',
        direction: 'right',
        widthClass: 'w-full md:w-[440px]',
        component: defineAsyncComponent(() => import('../drawer/DrawerContextSearchMeili.vue')),
    },
    {
        type: 'filter',
        direction: 'right',
        widthClass: 'w-full md:w-[440px]',
        component: defineAsyncComponent(() => import('../drawer/DrawerContextFilter.vue')),
    },
    {
        type: 'searchFilter',
        direction: 'right',
        widthClass: 'w-full md:w-[440px]',
        component: defineAsyncComponent(() => import('../drawer/DrawerContextSearchFilter.vue')),
    },
]
</script>

<template>
    <template v-for="ctx in contexts" :key="ctx.type">
        <SidenavOverlay
            v-slot="{ shouldRender }"
            :model-value="isOpen(ctx.type).value"
            :direction="ctx.direction"
            :width-class="ctx.widthClass"
            @update:model-value="(val) => isOpen(ctx.type).value = !!val"
        >
            <component
                :is="ctx.component"
                v-if="shouldRender || ctx.type === 'filter' || ctx.type === 'searchFilter'"
                v-show="shouldRender"
            />
        </SidenavOverlay>
    </template>
</template>
